import { responseMiddleware } from "services/alert";

const resource = "api/partyLookup";

const get = (data: { filters: { value: string }[] }) => {
    const { value } = data.filters[0];
    return fetch(`/${resource}/get?query=${value}`, {
        cache: "default",
        headers: {
            "X-Device-Id": localStorage.getItem("deviceId") ?? "",
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json; charset=utf-8",
        },
        method: "GET",
    })
        .then((res) => responseMiddleware(res, {}))
        .catch((err) => console.error({ type: "error", message: "Неудачный запрос", title: "Ошибка.", err }));
};

export { get };
